/**
 * Project setup redesign — per-track dictionary fragments.
 *
 * Several tracks add copy at the same time; one file per track keeps them out
 * of each other's way in the 14k-line en.ts / nl.ts. Each fragment's NL is
 * typed against its EN, so lockstep holds per fragment.
 */
import { oauthReturnEn, oauthReturnNl } from "./oauth-return";
import { mailboxSetupEn, mailboxSetupNl } from "./mailbox";
import { checklistEn, checklistNl } from "./checklist";
import { connectionsSetupEn, connectionsSetupNl } from "./connections";
import { settingsAreasEn, settingsAreasNl } from "./settings-areas";
import { customerCommunicationEn, customerCommunicationNl } from "./customer-communication";

export const projectSetupEn = {
  ...oauthReturnEn,
  ...mailboxSetupEn,
  ...checklistEn,
  ...connectionsSetupEn,
  ...settingsAreasEn,
  ...customerCommunicationEn,
};

export const projectSetupNl: typeof projectSetupEn = {
  ...oauthReturnNl,
  ...mailboxSetupNl,
  ...checklistNl,
  ...connectionsSetupNl,
  ...settingsAreasNl,
  ...customerCommunicationNl,
};
